import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-h03" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "p-the-h03-detail" }
const _hoisted_7 = {
  class: "p-the-h03-detail__text",
  "data-translate-skip": ""
}
const _hoisted_8 = { class: "p-badge" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "p-badge__name" }
const _hoisted_11 = {
  class: "p-the-h03__text",
  "data-translate-skip": ""
}
const _hoisted_12 = {
  class: "p-the-h03__text",
  "data-translate-skip": ""
}
const _hoisted_13 = { class: "p-the-h03__text" }
const _hoisted_14 = { "data-translate-skip": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_HGivePointPageIcon = _resolveComponent("HGivePointPageIcon")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_HContainer = _resolveComponent("HContainer")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_TheHDetail = _resolveComponent("TheHDetail")!
  const _component_TheTemplateH = _resolveComponent("TheTemplateH")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        (_ctx.giveData.give_details)
          ? (_openBlock(), _createBlock(_component_TheTemplateH, {
              key: 0,
              heading: "ポイント詳細"
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              "header-label": _withCtx(() => [
                (_ctx.approvalEnabled && _ctx.approved === 'approved')
                  ? (_openBlock(), _createBlock(_component_TextLabel, {
                      key: 0,
                      color: { border: '#616161', content: '#ffffff' },
                      reverse: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.approvedLabel), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              contents: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_TheHDetail, {
                    image: true,
                    "usage-point": _ctx.givePoint
                  }, _createSlots({
                    image: _withCtx(() => [
                      (_ctx.point.state === 'give')
                        ? (_openBlock(), _createBlock(_component_HGivePointPageIcon, {
                            key: 0,
                            from: _ctx.userIcon,
                            to: _ctx.image
                          }, null, 8, ["from", "to"]))
                        : (_ctx.point.state === 'given')
                          ? (_openBlock(), _createBlock(_component_IconUserImage, {
                              key: 1,
                              size: _ctx.userImageSize
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: _ctx.image,
                                  alt: ""
                                }, null, 8, _hoisted_5)
                              ]),
                              _: 1
                            }, 8, ["size"]))
                          : _createCommentVNode("", true)
                    ]),
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_SmallText, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.giveData.give_details.give_id.label) + "  " + _toDisplayString(_ctx.giveData.give_details.give_id.id), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.giveDetails.give_to), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createVNode(_component_SmallText, { "data-translate-skip": "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.giveDetails.group_name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createVNode(_component_SmallText, null, {
                              default: _withCtx(() => [
                                _createTextVNode("ID：" + _toDisplayString(_ctx.giveDetails.group_code), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    body: _withCtx(() => [
                      (_ctx.giveData.giftBadgeInfo?.name)
                        ? (_openBlock(), _createBlock(_component_HContainer, {
                            key: 0,
                            "margin-size": "m"
                          }, {
                            content: _withCtx(() => [
                              _createVNode(_component_SmallText, null, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                  _createTextVNode("バッジ", -1)
                                ])),
                                _: 1,
                                __: [0]
                              }),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("img", {
                                  src: _ctx.giveData.giftBadgeInfo.icon,
                                  class: "p-badge__icon",
                                  alt: ""
                                }, null, 8, _hoisted_9),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.giveData.giftBadgeInfo.name), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_HContainer, { "margin-size": "m" }, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("タイトル", -1)
                            ])),
                            _: 1,
                            __: [1]
                          }),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.message.title), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HContainer, { "margin-size": "m" }, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("メッセージ", -1)
                            ])),
                            _: 1,
                            __: [2]
                          }),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.message.text), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HContainer, { "margin-size": "m" }, _createSlots({ _: 2 }, [
                        (_ctx.messsageThreadEnabled)
                          ? {
                              name: "content",
                              fn: _withCtx(() => [
                                _createVNode(_component_ButtonMain, {
                                  tag: "a",
                                  kind: "secondary",
                                  reverse: true,
                                  href: _ctx.message.url
                                }, {
                                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode(" メッセージスレッドを見る ", -1)
                                  ])),
                                  _: 1,
                                  __: [3]
                                }, 8, ["href"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1024),
                      _createVNode(_component_HContainer, { "margin-size": "l" }, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.giveDetails.dateLabel), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.giveDetails.date), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, [
                    (_ctx.point.expiration)
                      ? {
                          name: "point",
                          fn: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.point.expiration, ({ label, date }, key) => {
                              return (_openBlock(), _createBlock(_component_SmallText, { key: key }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(label) + " ", 1),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(date), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["usage-point"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FloatingGivePointButton),
    _createVNode(_component_TheFooter)
  ]))
}